import { useId } from "react";

import type { GuidedContent } from "../navigation";
import { useGuidedMode } from "./guidedModeState";

interface GuidedPanelProps {
  content: GuidedContent;
}

export function GuidedPanel({ content }: GuidedPanelProps) {
  const headingId = useId();
  const { setEnabled } = useGuidedMode();

  return (
    <aside className="guided-panel" aria-labelledby={headingId}>
      <div className="guided-panel__marker" aria-hidden="true">
        <span>Next</span>
        <strong>→</strong>
      </div>
      <div className="guided-panel__content">
        <h2 id={headingId}>{content.title}</h2>
        <p>{content.nextStep}</p>
        <details>
          <summary>Why</summary>
          <p>{content.help}</p>
        </details>
      </div>
      <button
        className="guided-panel__dismiss"
        type="button"
        onClick={() => setEnabled(false)}
      >
        Hide help
      </button>
    </aside>
  );
}
